<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="padding: 10px;"
                cols="12"
                lg="2"
                md="3"
                sm="12"
            >
                <h3>Pipeline Construction - Outdoor</h3>
            </v-col>
            <v-col 
                style="padding-top: 10px; display: flex;"
                cols="12"
                lg="2"
                md="12"
                sm="12"
            >
                <v-combobox
                    v-model="sortSelected"
                    :items="listSortOptions"
                    label="Sort By"
                    item-text="description"
                    item-value="id"
                    clearable
                    outlined
                    @change="sortRegisters"
                    dense
                ></v-combobox>

                <v-tooltip bottom v-if="sortType == 0">
                    <template v-slot:activator="{ on }" v-if="sortType == 0">
                        <v-btn class="btnToogle" v-on="on" v-if="sortType == 0" @click="sortType = 1; sortRegisters()">
                            <v-icon>mdi-sort-ascending</v-icon>
                        </v-btn>
                    </template>
                    <span>Order by ascending</span>
                </v-tooltip>

                <v-tooltip bottom v-if="sortType == 1">
                    <template v-slot:activator="{ on }" v-if="sortType == 1">
                        <v-btn class="btnToogle" v-on="on" v-if="sortType == 1" @click="sortType = 0; sortRegisters()">
                            <v-icon>mdi-sort-descending</v-icon>
                        </v-btn>
                    </template>
                    <span>Order by descending</span>
                </v-tooltip>
            </v-col>
            <v-col 
                style="padding: 10px;"
                cols="12"
                lg="2"
                md="12"
                sm="12"
            >
                <v-combobox
                    :items="listUser"
                    label="Search by Supervisor"
                    item-text="name"
                    item-value="id"
                    multiple
                    clearable
                    single-line
                    outlined
                    dense
                ></v-combobox>
            </v-col>
            <v-col 
                style="padding: 10px;"
                cols="12"
                lg="2"
                md="12"
                sm="12"
            >
                <v-autocomplete
                    v-model="projectSelected"
                    :items="listProjects"
                    :loading="isLoading"
                    :search-input.sync="searchProject"
                    hide-selected
                    :no-data-text="textNoData"
                    item-text="description"
                    item-value="id"
                    placeholder="Card Search"
                    prepend-inner-icon="mdi mdi-magnify"
                    outlined
                    return-object
                    dense
                ></v-autocomplete>
            </v-col>
            <v-col 
                style="padding: 10px;"
                cols="12"
                lg="2"
                md="12"
                sm="12"
            >
                <v-form @submit.prevent="getRegisters">
                    <v-text-field
                        v-model="filter.fastSearch"
                        label="Filter Current View"
                        prepend-inner-icon="mdi mdi-filter"
                        outlined
                        single-line
                        @keyup="filteredSearch"
                        @click:prepend-inner="getRegisters"
                        dense
                    ></v-text-field>
                </v-form>
            </v-col>
            <v-col 
                style="padding-top: 10px; display: flex;"
                cols="12"
                lg="2"
                md="2"
                sm="12"
            >
                <v-combobox
                    v-model="daysRemaingSelected"
                    :items="listDaysRemaining"
                    label="Days Remaining"
                    item-text="description"
                    clearable
                    outlined
                    @change="filteredSearch"
                    dense
                ></v-combobox>
            </v-col>
        </v-row>

        <div id="divHeaders" style="width: 100%; overflow-x: auto" class="sticky" @scroll="syncScroll">

            <v-row 
                class="rowWrap"
            >
                <v-col 
                    v-for="(itemCard, index) in listCards" :key="index"
                    class="colWrap"
                    cols="12"
                    lg="2"
                    md="4"
                    sm="12"
                >
                    <v-card>
                        <v-card-title :class="`text-h6 lighten-2 pipelineTitle ${itemCard.cssClass}`">
                            <v-col 
                                cols="10"
                            >
                                <v-icon left class="pipelineWhiteColor">mdi mdi-card-text-outline</v-icon>
                                <label class="pipelineWhiteColor">{{ itemCard.title }}</label>
                            </v-col>
                            <v-col 
                                cols="2"
                                style="text-align: right;"
                            >
                                <label class="pipelineWhiteColor"> {{ itemCard.qtd }} </label>
                            </v-col>
                        </v-card-title>
                    </v-card>
                </v-col>

            </v-row>
        </div>

        <div id="divContents" style="width: 101%; overflow-x: auto" @scroll="syncScroll">
            <v-row 
                class="rowWrap"
            >
                <v-col 
                    v-for="(itemCard, index) in listCards" :key="index"
                    class="colWrap"
                    cols="12"
                    lg="2"
                    md="4"
                    sm="12"
                >   
                    <v-card 
                        class="pipelineDetails"
                        v-for="(itemProject, index) in itemCard.listItems" :key="index"
                    >
                        <ConstructionCard
                            :id="itemProject.id"
                            :itemProject="{...itemProject}"
                            :itemCard="{...itemCard}"
                            :firstStatus="PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERFRAME.id"
                            :lastStatus="PROJECT_STATUS.CONSTRUCTION_PERGOLA_FINALINSPECTION.id"
                            :listStatusOriginal="listStatusOriginal"
                            :listConstructionActions="listConstructionActions"
                            :salesModule="salesModule"
                            :draftingModule="draftingModule"
                            :listContractor="listContractor"
                            :listConstructionPanel="listConstructionPanel"
                            :listConstructionStages="listConstructionStages"
                            :listUser="listUser"
                            :trackType="TRACK_TYPE.PERGOLA.id"
                            v-on:methodConfirmToCall="getRegisters()"
                        />
                    </v-card>
                    
                </v-col>

            </v-row>
        </div>
        
    </v-container>
</template>

<script>
    import Helpers from '@/utilities/Helpers';
    import { filterValuePart, orderBy } from '@/utilities/Utils';
    import ConstructionCard from "@/components/Services/ConstructionCard";
    import { PROJECT_STATUS, TRACK_TYPE } from "@/utilities/Enums";
    import { filterByTrackStatus } from "@/utilities/TrackUtils";

    export default ({

        mixins: [Helpers],

        components: {
            ConstructionCard
        },

        data: () => ({

            filter: {
                fastSearch: ''
            },

            idPanel: 9,
            listUser: [],

            listCards:[],

            listFooterFrame: [],
            listFooterFrameFiltered: [],
            qtdFooterFrame: 0,

            listInspectionFooter: [],
            listInspectionFooterFiltered: [],
            qtdInspectionFooter: 0,

            listFooterSpoured: [],
            listFooterSpouredFiltered: [],
            qtdFooterSpoured: 0,

            listFooterFinalInspection: [],
            listFooterFinalInspectionFiltered: [],
            qtdFooterFinalInspection: 0,

            listColumnInstallation: [],
            listColumnInstallationFiltered: [],
            qtdColumnInstallation: 0,

            listElectricInstallation: [],
            listElectricInstallationFiltered: [],
            qtdElectricInstallation: 0,

            listFramingColumn: [],
            listFramingColumnFiltered: [],
            qtdFramingColumn: 0,

            listFinishInstallation: [],
            listFinishInstallationFiltered: [],
            qtdFinishInstallation: 0,

            listFinalInspection: [],
            listFinalInspectionFiltered: [],
            qtdFinalInspection: 0,

            sortSelected: null,
            sortType: 0,
            listSortOptions: [
                { id: 1, description: 'Registration Date', listField: ['id'] },
                { id: 2, description: 'Deadline', listField: ['datePermittingStep1DeadlineDays', 'datePermittingStep2DeadlineDays', 'datePermittingStep3DeadlineDays', 'datePermittingStep4DeadlineDays', 'datePermittingStep4DeadlineDays'] },
                { id: 3, description: 'Responsible', listField: ['permitterUserName'] },
                { id: 4, description: 'Supervisor', listField: ['id'] },
                { id: 5, description: 'Contract Amount', listField: ['contractValue'] }
            ],
            textNoData: 'Type to search a project...',
            projectSelected: null,
            searchProject: null,
            listProjects: [],
            isLoading: false,

            daysRemaingSelected: null,
            listDaysRemaining: [],

            listStatusOriginal: [],
            listConstructionActions: [],
            salesModule: {},
            draftingModule: {},

            listContractor: [],
            listConstructionPanel: [],
            listConstructionStages: [],

            PROJECT_STATUS,
            TRACK_TYPE
        }),

        watch: {
            async searchProject(search) {
                
                if (search == null || search == undefined || search.toString().trim() == '') {
                    this.listProjects = [];
                    this.textNoData = "Type to search a project...";
                }
                else {

                    if (this.listProjects.length <= 0) {
                        this.textNoData = "No projects found";
                    }

                    this.isLoading = true;

                    this.listProjects = await this.$store.dispatch("serviceModule/ListProjectCompact", search);

                    this.isLoading = false;
                }
            }
        },

        methods: {

            filteredSearch() {

                const filter = this.filter.fastSearch.toLowerCase();                
                
                this.listCards.forEach(itemCard => {

                    itemCard.listItems = filterValuePart(itemCard.listItemsClone, filter, ['step', 'customerAddress', 'dateScopeWorkStep4Formatted', 'sellerName', 'customerName', 'nameProject', 'idFormatted']);

                    if (this.daysRemaingSelected != null && this.daysRemaingSelected != undefined) {
                        itemCard.listItems = filterValuePart(itemCard.listItems, this.daysRemaingSelected.description, ['dueDateDeadlineDays']);
                    }
                })

                return null;
            },

            sortRegisters() {

                let field = ['id'];

                if (this.sortSelected != null && this.sortSelected != undefined) {
                    field = this.sortSelected.listField;
                }
                
                this.listCards.forEach(itemCard => {

                    itemCard.listItems.sort((a, b) => { return orderBy(a, b, this.sortType, field[0]) });

                })
            },

            async getLists() {
                const listStatus = await this.$store.dispatch("serviceModule/ListStatus");
                this.listStatusOriginal = listStatus.sort((a, b) => { return orderBy(a, b, 0, 'id') });

                const listConstructionActions = await this.$store.dispatch("actionsModule/List");
                this.listConstructionActions = listConstructionActions.filter(act => act.status == 1);

                const listModules = await this.$store.dispatch("moduleModule/List");
                this.salesModule = listModules.filter(mod => mod.id == 1)[0];
                this.draftingModule = listModules.filter(mod => mod.id == 2)[0];

                this.listContractor = await this.$store.dispatch("contractorModule/List");
                this.listConstructionPanel = await this.$store.dispatch("serviceModule/ListConstructionPanel");
                this.listConstructionStages = await this.$store.dispatch("serviceModule/ListConstructionStages");
                
                const listUserResponse = await this.$store.dispatch("userModule/List");
                this.listUser = listUserResponse.filter(usr => usr.constructionSupervisor == 1);
            },

            async getRegisters() {

                this.showLoading();

                this.sortSelected = this.listSortOptions[0];

                const response = await this.$store.dispatch("serviceModule/ListPipelineConstruction", {
                    statusStart: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERFRAME.id,
                    statusEnd: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FINALINSPECTION.id,
                    pergola: 1,
                    bbq: 0,
                    pool: 0
                });

                if (response != null && response != undefined) {

                    this.listCards = [];

                    if (response.listPipeline && response.listPipeline != null && response.listPipeline != undefined) {

                        this.listFooterFrame = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERFRAME.id, TRACK_TYPE.PERGOLA.id)];
                        if (this.listFooterFrame != null && this.listFooterFrame != undefined) {
                            this.qtdFooterFrame = this.listFooterFrame.length;
                        }
                        this.listFooterFrameFiltered = [...this.listFooterFrame];

                        this.listInspectionFooter = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_INSPECTIONSFOOTERBONDFOOTERFORMSFOOTERFOUNDATION.id, TRACK_TYPE.PERGOLA.id)];
                        if (this.listInspectionFooter != null && this.listInspectionFooter != undefined) {
                            this.qtdInspectionFooter = this.listInspectionFooter.length;
                        }
                        this.listInspectionFooterFiltered = [...this.listInspectionFooter];


                        this.listFooterSpoured = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERSPOURED.id, TRACK_TYPE.PERGOLA.id)];
                        if (this.listFooterSpoured != null && this.listFooterSpoured != undefined) {
                            this.qtdFooterSpoured = this.listFooterSpoured.length;
                        }
                        this.listFooterSpouredFiltered = [...this.listFooterSpoured];


                        this.listFooterFinalInspection = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERFINALINSPECTION.id, TRACK_TYPE.PERGOLA.id)];
                        if (this.listFooterFinalInspection != null && this.listFooterFinalInspection != undefined) {
                            this.qtdFooterFinalInspection = this.listFooterFinalInspection.length;
                        }
                        this.listFooterFinalInspectionFiltered = [...this.listFooterFinalInspection];


                        this.listColumnInstallation = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_COLUMNINSTALLATION.id, TRACK_TYPE.PERGOLA.id)];
                        if (this.listColumnInstallation != null && this.listColumnInstallation != undefined) {
                            this.qtdColumnInstallation = this.listColumnInstallation.length;
                        }
                        this.listColumnInstallationFiltered = [...this.listColumnInstallation];


                        this.listElectricInstallation = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_ELECTRICINSTALLATION.id, TRACK_TYPE.PERGOLA.id)];
                        if (this.listElectricInstallation != null && this.listElectricInstallation != undefined) {
                            this.qtdElectricInstallation = this.listElectricInstallation.length;
                        }
                        this.listElectricInstallationFiltered = [...this.listElectricInstallation];


                        this.listFramingColumn = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FRAMINGCOLUMNCOLUMNBONDFINALELECTRICINSPECTION.id, TRACK_TYPE.PERGOLA.id)];
                        if (this.listFramingColumn != null && this.listFramingColumn != undefined) {
                            this.qtdFramingColumn = this.listFramingColumn.length;
                        }
                        this.listFramingColumnFiltered = [...this.listFramingColumn];


                        this.listFinishInstallation = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FINISHINSTALLATION.id, TRACK_TYPE.PERGOLA.id)];
                        if (this.listFinishInstallation != null && this.listFinishInstallation != undefined) {
                            this.qtdFinalElelistFinishInstallation = this.listFinishInstallation.length;
                        }
                        this.listFinishInstallationFiltered = [...this.listFinishInstallation];


                        this.listFinalInspection = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FINALINSPECTION.id, TRACK_TYPE.PERGOLA.id)];
                        if (this.listFinalInspection != null && this.listFinalInspection != undefined) {
                            this.qtdFinalElelistFinalInspection = this.listFinalInspection.length;
                        }
                        this.listFinalInspectionFiltered = [...this.listFinalInspection];

                        const listPipelines = [...this.listFooterFrameFiltered,
                                                ...this.listInspectionFooterFiltered,
                                                ...this.listFooterSpouredFiltered,
                                                ...this.listFooterFinalInspectionFiltered,
                                                ...this.listColumnInstallationFiltered,
                                                ...this.listElectricInstallationFiltered,
                                                ...this.listFramingColumnFiltered,
                                                ...this.listFinishInstallationFiltered,
                                                ...this.listFinalInspectionFiltered
                                              ];

                        const listDaysRemaining = listPipelines.map(item => { return { description: item.dueDateDeadlineDays } } );

                        this.listDaysRemaining = [...new Set(listDaysRemaining.sort((a, b) => { return orderBy(a, b, 1, 'description') }))];

                        
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERFRAME.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERFRAME.id,
                            qtd: this.listFooterFrame.length,
                            listItems: this.listFooterFrame,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: 42,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: false,
                                workOrder: false,
                                workOrderRequest: false,
                                inspection: false,
                                showAdvanceButton: true,
                                showBackButton: false,
                            },
                        })
                        
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_INSPECTIONSFOOTERBONDFOOTERFORMSFOOTERFOUNDATION.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_INSPECTIONSFOOTERBONDFOOTERFORMSFOOTERFOUNDATION.id,
                            qtd: this.listInspectionFooter.length,
                            listItems: this.listInspectionFooter,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: 43,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: true,
                                workOrder: true,
                                workOrderRequest: true,
                                inspection: true,
                                showAdvanceButton: true,
                                showBackButton: false
                            },
                        })
                        
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERSPOURED.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERSPOURED.id,
                            qtd: this.listFooterSpoured.length,
                            listItems: this.listFooterSpoured,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: 44,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: true,
                                workOrder: true,
                                workOrderRequest: true,
                                inspection: true,
                                showAdvanceButton: true,
                                showBackButton: true
                            },
                        })
                        
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERFINALINSPECTION.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERFINALINSPECTION.id,
                            qtd: this.listFooterFinalInspection.length,
                            listItems: this.listFooterFinalInspection,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: 45,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: true,
                                workOrder: true,
                                workOrderRequest: true,
                                inspection: true,
                                showAdvanceButton: true,
                                showBackButton: true
                            },
                        })
                        
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_COLUMNINSTALLATION.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_COLUMNINSTALLATION.id,
                            qtd: this.listColumnInstallation.length,
                            listItems: this.listColumnInstallation,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: 46,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: true,
                                workOrder: true,
                                workOrderRequest: true,
                                inspection: true,
                                showAdvanceButton: true,
                                showBackButton: true
                            },
                        })
                        
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_ELECTRICINSTALLATION.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_ELECTRICINSTALLATION.id,
                            qtd: this.listElectricInstallation.length,
                            listItems: this.listElectricInstallation,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: 47,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: true,
                                workOrder: true,
                                workOrderRequest: true,
                                inspection: true,
                                showAdvanceButton: true,
                                showBackButton: true
                            },
                        })
                        
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FRAMINGCOLUMNCOLUMNBONDFINALELECTRICINSPECTION.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FRAMINGCOLUMNCOLUMNBONDFINALELECTRICINSPECTION.id,
                            qtd: this.listFramingColumn.length,
                            listItems: this.listFramingColumn,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: 48,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: true,
                                workOrder: true,
                                workOrderRequest: true,
                                inspection: true,
                                showAdvanceButton: true,
                                showBackButton: true
                            },
                        })
                        
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FINISHINSTALLATION.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FINISHINSTALLATION.id,
                            qtd: this.listFinishInstallation.length,
                            listItems: this.listFinishInstallation,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: 49,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: true,
                                workOrder: true,
                                workOrderRequest: true,
                                inspection: true,
                                showAdvanceButton: true,
                                showBackButton: true
                            },
                        })
                                                
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FINALINSPECTION.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FINALINSPECTION.id,
                            qtd: this.listFinalInspection.length,
                            listItems: this.listFinalInspection,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: 50,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: true,
                                workOrder: true,
                                workOrderRequest: true,
                                inspection: true,
                                showAdvanceButton: false,
                                showBackButton: true
                            },
                        })
                
                        this.listCards.forEach(itemCard => {

                            itemCard.listItemsClone = [...itemCard.listItems];

                        });
                    }
                }

                this.hideLoading();
            },
        },

        async created() {
            await this.getLists();
            await this.getRegisters();
        },
    })
</script>

<style scoped>

    .colorPipeline {
        background-color: var(--color__construction_dashboard_pergola);
    }

    .v-progress-linear__determinate {
        background-color: var(--color__construction_dashboard_pergola) !important; 
    }
</style>